import React from 'react';
import Skeleton from '../../../Components/skeleton/skeleton';
import OrderListLoader from '../../order-list/loader';
import PanelCard from '../../../Components/panel-card/panel-card';
import './details-listing.scss';

export default function DetailsListingLoader() {
  return (
    <div className="details-listing-container">
      <div className="details-listing-header">
        <h3 className="title">
          <Skeleton
            skWidth="6.944vw"
            skHeight="0.972vw"
            marginTop="0.556vw"
            marginBottom="0.556vw"
          />
        </h3>
        <div className="button-section">
          <Skeleton skHeight="2.083vw" skWidth="6.597vw" skRadius="2.083vw" />
          <Skeleton
            skHeight="2.083vw"
            skWidth="6.111vw"
            skRadius="2.083vw"
            marginLeft="1.25vw"
          />
          <Skeleton
            skHeight="2.083vw"
            skWidth="11.528vw"
            skRadius="2.083vw"
            marginLeft="1.25vw"
          />
        </div>
      </div>

      <div className="details-listing-body">
        <PanelCard noSpacing>
          <OrderListLoader removeUserGroup />
        </PanelCard>
      </div>
    </div>
  );
}
